var moduleMap = {
	"./BillerResource": () => {
		return Promise.all([__webpack_require__.e(711), __webpack_require__.e(543), __webpack_require__.e(350), __webpack_require__.e(326), __webpack_require__.e(236), __webpack_require__.e(716), __webpack_require__.e(573), __webpack_require__.e(342), __webpack_require__.e(286), __webpack_require__.e(849)]).then(() => (() => ((__webpack_require__(89849)))));
	},
	"./BillerNavigation": () => {
		return __webpack_require__.e(581).then(() => (() => ((__webpack_require__(581)))));
	},
	"./billerCore": () => {
		return Promise.all([__webpack_require__.e(711), __webpack_require__.e(543), __webpack_require__.e(525), __webpack_require__.e(350), __webpack_require__.e(326), __webpack_require__.e(236), __webpack_require__.e(716), __webpack_require__.e(573), __webpack_require__.e(342), __webpack_require__.e(286), __webpack_require__.e(220)]).then(() => (() => ((__webpack_require__(72220)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});